import React, { useCallback, useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { useDownloadApp } from '../utils/download';
import { useRequestDemo } from '../utils/demo';
import RequestDemoForm from './RequestDemoForm';
import apiClient from '../utils/apiClient';

const Footer = () => {
  const { popupAppClick } = useDownloadApp();

  const { popupDemo, popupDemoClick } = useRequestDemo();

  const [input, setInput] = useState({
    email: '',
  });

  const [successMessage, setSuccessMessage] = useState('');

  const inputChangeHandler = useCallback((e) => {
    const { name, value } = e.target;

    setInput((state) => ({ ...state, [name]: value }));
  }, []);

  const closeDemoOpenDownload = useCallback((e) => {
    popupDemoClick(e);
    popupAppClick(e);
  }, []);

  const submitHandler = useCallback(
    (e) => {
      e.preventDefault();

      (async () => {
        try {
          await apiClient.post('/request-demo', {
            data: JSON.stringify({ contact: input }),
          });

          setInput({
            email: '',
          });
          setSuccessMessage('Subscribed Succesfully');
        } catch (error) {
          /* do nothing */
        }
      })();
    },
    [input],
  );

  useEffect(() => {
    if (successMessage) {
      const timeout = setTimeout(() => {
        setSuccessMessage('');
      }, 5000);

      return () => {
        clearTimeout(timeout);
      };
    }

    return () => {
      /* do nothing */
    };
  }, [successMessage]);

  return (
    <>
      <section className="footer-cta-main pad100">
        <div className="container">
          <h2 className="heading-big white-heading">
            Download the Powerplay mobile app
          </h2>
          <div className="cta-btns">
            <button type="button" className="button" onClick={popupAppClick}>
              Download now
            </button>
            <button
              type="button"
              onClick={popupDemoClick}
              className="button button-border">
              Request demo
            </button>
          </div>
        </div>
      </section>
      <footer>
        <div className="footer-tp">
          <div className="container">
            <div className="flex-row">
              <div className="col-4 col">
                <div className="footer-about">
                  <img
                    src="/img/powerplay-logo.svg"
                    width="198px"
                    style={{ marginBottom: '20px' }}
                    alt="Powerplay"
                  />
                  <p>
                    We’re a mobile app ecosystem that simplifies site-to-office
                    communication for better collaboration on your construction
                    projects.
                  </p>
                </div>
                <div className="footer-app-links">
                  <p style={{ fontWeight: '500' }}>Download the app</p>
                  <a
                    href="https://play.google.com/store/apps/details?id=in.powerplay.android.fieldapp&hl=en_IN"
                    target="_blank"
                    rel="noopener noreferrer">
                    <img src="/img/play-store.svg" alt="playstore" />
                  </a>
                  <a
                    href="https://apps.apple.com/app/id1552606148"
                    target="_blank"
                    rel="noopener noreferrer">
                    <img src="/img/app-store.svg" alt="appstore" />
                  </a>
                </div>
              </div>
              <div className="col-6 offset-2 col">
                <div className="footer-links-main">
                  <div className="single-link-col">
                    <h4>Company</h4>
                    <ul>
                      <li>
                        <Link to="/about/"> About</Link>
                      </li>
                      <li>
                        <Link to="/product/"> Product</Link>
                      </li>
                      <li>
                        <Link to="/career/">
                          Careers
                          <span className="hiring-badge">We’re hiring!</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="single-link-col">
                    <h4>Resources</h4>
                    <ul>
                      <li>
                        <Link to="/blog/"> Blog</Link>
                      </li>
                      <li>
                        <a
                          href="https://portal.getpowerplay.in/login"
                          target="_blank"
                          rel="noopener noreferrer">
                          Login
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="single-link-col">
                    <h4>Legal</h4>
                    <ul>
                      {/* <li>
                        <Link to="#!"> Terms</Link>
                      </li> */}
                      <li>
                        <Link to="/privacy-policy/"> Privacy</Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="newsletter-block">
                  <p style={{ fontWeight: '500' }}>
                    Don’t forget to subscribe to our newsletter!
                  </p>
                  <form onSubmit={submitHandler}>
                    <div className="newsletter-input-area">
                      <input
                        type="email"
                        name="email"
                        placeholder="What’s your email?"
                        value={input.email}
                        onChange={inputChangeHandler}
                        required
                      />
                      <button type="submit" className="button">
                        Subscribe
                      </button>
                    </div>
                    {successMessage && (
                      <small className="success-message">
                        {successMessage}
                      </small>
                    )}
                  </form>
                </div>
                <div className="social-links">
                  <p style={{ fontWeight: '500' }}>Follow us on:</p>
                  <a
                    href="https://www.facebook.com/Powerplay-App-111342077401751"
                    rel="noreferrer noopener"
                    target="_blank">
                    <img src="/img/facebook.svg" alt="facebook" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/getpowerplay/"
                    rel="noreferrer noopener"
                    target="_blank">
                    <img src="/img/linkedin-footer.svg" alt="twitter" />
                  </a>
                  <a
                    href="https://www.instagram.com/powerplay_app/"
                    rel="noreferrer noopener"
                    target="_blank">
                    <img src="/img/instagram.svg" alt="instagram" />
                  </a>
                  <a
                    href="https://twitter.com/Powerplay_app"
                    rel="noreferrer noopener"
                    target="_blank">
                    <img src="/img/twitter.svg" alt="instagram" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-block">
          <div className="container">
            <div className="flex-row">
              <div className="col-6 col">
                <p>
                  © 2021 Coffer Internet Services Pvt. Ltd. | All rights
                  reserved
                </p>
              </div>
              <div className="col-6 col">
                <p className="footer-loc">
                  Bengaluru, India&nbsp;
                  <img src="/img/indian-flag.png" alt="indian flag" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div
        className={
          popupDemo ? 'download-app-popup show' : 'download-app-popup'
        }>
        <div className="popup-block">
          <button type="button" className="close-pop" onClick={popupDemoClick}>
            <svg
              width="16px"
              x="0px"
              y="0px"
              viewBox="0 0 13.7 13.7"
              style={{ enableBackground: 'new 0 0 13.7 13.7' }}>
              <path
                d="M13.6,12.1c0.1,0.1,0.1,0.4,0,0.5l-1,1c-0.1,0.1-0.3,0.1-0.5,0l-0.9-0.9L6.8,8.3l-5.3,5.3c-0.1,0.1-0.4,0.1-0.5,0l-1-1
                  c-0.1-0.1-0.1-0.3,0-0.5l5.3-5.3L0.1,1.6C0,1.4,0,1.2,0.1,1.1l1-1C1.2,0,1.4,0,1.6,0.1l5.3,5.3l5.3-5.3c0.1-0.1,0.3-0.1,0.5,0l1,1
                  c0.1,0.1,0.1,0.3,0,0.5l-0.9,0.9L8.3,6.8L13.6,12.1z"
              />
            </svg>
          </button>
          <h2 className="heading" style={{ marginBottom: '10px' }}>
            Request a demo
          </h2>

          <p>
            Tell us a few things about yourself and we&apos;ll show you a lot
            more about us.
          </p>

          <RequestDemoForm closeDemoOpenDownload={closeDemoOpenDownload} />
        </div>
      </div>
    </>
  );
};

export default Footer;
